module.exports = __webpack_public_path__ + "img/lineup-black.a5c85a57.svg";